exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iqcio_universe_contentOne{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.iqcio_universe_contentOne .iq-btn1{cursor:pointer !important;border:1px solid var(--text-light-blue);background:#fff;border-radius:15px !important;overflow:hidden;padding:6px 14px;position:relative;text-align:center;width:auto;margin-right:5px}.iqcio_universe_contentOne_btnGroup{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.iqcio_universe_contentTwo{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center}.iqcio_universe__downloadTable{display:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/MyUniverse/universe/myUniverse.styles.scss
// module id = 1591
// module chunks = 0